import { DateFormat } from "../Helper";
const CollectionSummary = ({ collections }) => {
  if (!collections) collections = [];
  return (
    <>
      <h5 className="font-size-15">Collection Summary</h5>
      <hr className="my-2" />
      <div
        className="table-responsive overflow-auto"
        style={{ maxHeight: "500px" }}
      >
        <table className="table align-middle table-nowrap table-centered mb-0 print-reduce-font-size">
          <colgroup>
            <col style={{ width: "30px" }} />
            <col style={{ width: "40px" }} />
            <col />
            <col style={{ width: "90px" }} />
            <col />
            <col />
            <col style={{ width: "90px" }} />
            <col
              style={{ width: "50px", textAlign: "right" }}
              className="text-end"
            />
          </colgroup>
          <thead>
            <tr>
              <th>No.</th>
              <th>Date</th>
              <th>Voucher Num</th>
              <th>Ref Num</th>
              <th>Payer</th>
              <th>TPA</th>
              <th>Mode</th>
              <th className="text-end">Amount</th>
            </tr>
          </thead>

          <tbody>
            {collections.map((collection, index) => (
              <tr key={collection.bp_br_acnt_voucher_id}>
                <th scope="row">{index + 1}</th>
                <td>
                  <DateFormat value={collection.transaction_date} />
                </td>
                <td>{collection.bp_br_voucher_num}</td>
                <td>{collection.payment_transaction_ref_num}</td>
                <td>{collection.payer_name}</td>
                <td>{collection.tpa_name}</td>
                <td>{collection.payment_mode}</td>
                <td className="text-end">{collection.total_amount}</td>
              </tr>
            ))}
            {collections.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center">
                  No payment made yet
                </td>
              </tr>
            )}
            {/* <tr>
                        <th scope="row" colSpan="7" className="text-end">
                          Total Paid
                        </th>
                        <td className="text-end">
                          {calculateSum(collections, "total_amount")}
                        </td>
                      </tr> */}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CollectionSummary;
